import { useState } from 'react'

import { mixpanel } from '@/mixpanel'
import { useLogout } from '../../hooks/useLogout'
import { LogoutModal } from '../log-out-modal'

import type { ReactNode } from 'react'

type LogOutActionProps = {
  children: ReactNode
}

const LogOutAction = ({ children }: LogOutActionProps) => {
  const { softLogout } = useLogout()

  // State
  // ------------------------------------------------------------------------- /
  const [showModal, setShowModal] = useState<boolean>(false)

  // Interaction methods
  // ------------------------------------------------------------------------- /
  function handleShowModal() {
    setShowModal(true)
  }

  function handleHideModal() {
    setShowModal(false)
  }

  async function handleLogOut() {
    mixpanel.track('account_logout')

    await softLogout()
    setShowModal(false)

    // Navigation to Login happens in `Authenticated.tsx`
  }

  return (
    <>
      <button type='button' onClick={handleShowModal} title='Klik hier om je af te melden'>
        {children}
      </button>
      <LogoutModal isVisible={showModal} onAction={handleLogOut} onClose={handleHideModal} />
    </>
  )
}

export { LogOutAction }
